/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import PropTypes from "prop-types";

/**
 * Used to display a message when there is no data on the screen.
 * @param { string } message string
 * @param { string } xPosition horizontal alignment (start | center | end).
 * @param { string } yPosition vertical alignment (flex-start | center | flex-end).
 */
const EmptyPlaceholder = ({ message, inputStyles }) => {
	const defaultStyles = {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		textAlign: "center",
		height: "150px",
		margin: "5px 8px",
		padding: "20px 30px",
		color: "#9ca3af",
		fontStyle: "italic",
		fontSize: 16,
	};

	return (
		<div style={{ ...defaultStyles, ...inputStyles }}>
			<div className="d-inline w-100">
				<span data-test-id="empty-placeholder-message">{message}</span>
			</div>
		</div>
	);
};

EmptyPlaceholder.defaultProps = {
	inputStyles: {},
};
EmptyPlaceholder.propTypes = {
	message: PropTypes.string.isRequired,
	inputStyles: PropTypes.object,
};

export default EmptyPlaceholder;
